import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        if (user.temPermissao(['admin_seguros'])) {
            can('manage', 'SEGUROS')

        }

        if (user.temPermissao(['seguros'])) {
            can(['create', 'read', 'delete', 'edit'], 'SEGUROS');

        }
        if (user.temPermissao(['site_manager'])) {
            can('read', 'SEGUROS');
        }
    }

    return build()
}